import { __assign, __extends } from "tslib";
import React from "react";
import { FlatList, View } from "react-native";
import shallowequal from "../ShallowEqual.js";
import PnmacLoadEarlier from "../LoadEarlier";
import PnmacMessage from "../Message";
import PropTypes from "prop-types";
var PnmacMessageContainer = /** @class */function (_super) {
  __extends(PnmacMessageContainer, _super);
  function PnmacMessageContainer(props) {
    var _this = _super.call(this, props) || this;
    _this.renderFooter = function () {
      if (_this.props.renderFooter) {
        var footerProps = __assign({}, _this.props);
        return _this.props.renderFooter(footerProps);
      }
      return null;
    };
    _this.renderLoadEarlier = function () {
      if (_this.props.loadEarlier === true) {
        var loadEarlierProps = __assign({}, _this.props);
        if (_this.props.renderLoadEarlier) {
          return _this.props.renderLoadEarlier(loadEarlierProps);
        }
        return /*#__PURE__*/React.createElement(PnmacLoadEarlier, __assign({}, loadEarlierProps));
      }
      return null;
    };
    _this.renderRow = function (message) {
      if (!message._id && message._id !== 0) {
        console.warn("ChatBox: `_id` is missing for message", JSON.stringify(message));
      }
      if (!message.user) {
        console.warn("ChatBox: `user` is missing for message", JSON.stringify(message));
        message.user = {};
      }
      var messagePostion = message.user._id === _this.props.user._id ? "right" : "left";
      if (_this.props.iconOnTopLeft) {
        messagePostion = "topLeft";
      }
      var messageProps = __assign(__assign({}, _this.props), {
        key: message._id,
        currentMessage: message,
        previousMessage: message.previousMessage,
        nextMessage: message.nextMessage,
        position: messagePostion,
        iconOnTopLeft: _this.props.iconOnTopLeft || false,
        isTypingEvent: message.isTypingEvent || false
      });
      if (_this.props.renderMessage) {
        return _this.props.renderMessage(messageProps);
      }
      return /*#__PURE__*/React.createElement(PnmacMessage, __assign({
        key: Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15)
      }, messageProps));
    };
    _this.state = {
      dataSource: props.messages
    };
    return _this;
  }
  PnmacMessageContainer.prototype.shouldComponentUpdate = function (nextProps, nextState) {
    if (!shallowequal(this.props, nextProps)) {
      return true;
    }
    if (!shallowequal(this.state, nextState)) {
      return true;
    }
    return false;
  };
  PnmacMessageContainer.prototype.componentWillReceiveProps = function (nextProps) {
    if (this.props.messages === nextProps.messages) {
      return;
    }
    this.setState({
      dataSource: nextProps.messages
    });
  };
  PnmacMessageContainer.prototype.render = function () {
    var _this = this;
    return /*#__PURE__*/React.createElement(View, {
      ref: "container",
      style: {
        flex: 1,
        backgroundColor: "white"
      },
      testID: "messageContainer"
    }, /*#__PURE__*/React.createElement(FlatList, {
      data: this.state.dataSource,
      renderItem: function (_a) {
        var item = _a.item;
        return _this.renderRow(item);
      },
      keyExtractor: function (item, index) {
        return Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
      },
      refreshing: false,
      initialNumToRender: 8,
      ListHeaderComponent: this.renderFooter,
      ListFooterComponent: this.renderLoadEarlier
    }));
  };
  return PnmacMessageContainer;
}(React.Component);
PnmacMessageContainer.defaultProps = {
  messages: [],
  user: {},
  renderFooter: null,
  renderMessage: null,
  onLoadEarlier: function () {}
};
PnmacMessageContainer.propTypes = {
  messages: PropTypes.array,
  user: PropTypes.object,
  renderFooter: PropTypes.func,
  renderMessage: PropTypes.func,
  onLoadEarlier: PropTypes.func
};
export default PnmacMessageContainer;